/* eslint-disable max-len */
import * as React from 'react'
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      fill="#000"
      fillRule="nonzero"
      d="M19.351 20.981 9 31.175l5.719.78L10.926 39l9.968-10.036-4.758-.979 3.215-7.004Zm3.965-5.742c-.581 0-1.053.475-1.053 1.06v8.478c0 .585.472 1.06 1.053 1.06h6.316c.58 0 1.052-.475 1.052-1.06 0-.585-.471-1.06-1.052-1.06h-5.263V16.3c0-.585-.472-1.06-1.053-1.06ZM24.369 11c-6.97 0-12.632 5.701-12.632 12.717h2.106c0-5.85 4.715-10.597 10.526-10.597 5.81 0 10.526 4.747 10.526 10.597s-4.716 10.598-10.526 10.598c-1.777 0-3.45-.445-4.919-1.229l-1.364 1.662a12.499 12.499 0 0 0 6.283 1.686c6.97 0 12.631-5.7 12.631-12.717C37 16.701 31.34 11 24.369 11Z"
    />
  </svg>
)
export default SvgComponent
